function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const BookOpenedIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "book opened, book, pages",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 5.23333C10 5.23333 8.5 3.5 7.5 3.5H1.5V15.5H7.5C8.5 15.5 10 16.5 10 16.5M10 5.23333C10 5.23333 11.5003 3.5 12.55 3.5H18.5V15.5H12.55C11.5 15.5 10 16.5 10 16.5M10 5.23333V16.5M4.5 6.5H6.5M4.5 9.5H6.5M6.5 12.5H4.5M13.5 6.5H15.5M13.5 9.5H15.5M13.5 12.5H15.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default BookOpenedIcon;